module.exports = __webpack_public_path__ + "img/7.241eb183.png";